/**
 * Onde fica o cursor dentro de um textarea, em pixels a partir do canto do
 * próprio campo (AB#87442) — para a lista de `@` abrir onde se está digitando.
 *
 * O navegador não expõe essa posição; a técnica usual é copiar o texto até o
 * cursor para um `div` invisível com a mesma caixa e a mesma tipografia, e medir
 * onde cai um marcador no fim dele.
 */
const COPIED_STYLES = [
  "boxSizing",
  "width",
  "borderTopWidth",
  "borderRightWidth",
  "borderBottomWidth",
  "borderLeftWidth",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "fontFamily",
  "fontSize",
  "fontWeight",
  "fontStyle",
  "letterSpacing",
  "lineHeight",
  "textTransform",
  "wordSpacing",
  "tabSize",
] as const;

export function caretCoordinates(
  element: HTMLTextAreaElement,
  position: number,
): { top: number; left: number; height: number } {
  const style = window.getComputedStyle(element);
  const mirror = document.createElement("div");
  for (const name of COPIED_STYLES) mirror.style[name] = style[name];
  mirror.style.position = "absolute";
  mirror.style.visibility = "hidden";
  mirror.style.top = "0";
  mirror.style.left = "-9999px";
  mirror.style.whiteSpace = "pre-wrap";
  mirror.style.overflowWrap = "break-word";
  mirror.style.overflow = "hidden";
  mirror.textContent = element.value.slice(0, position);

  const marker = document.createElement("span");
  // Um caractere no marcador: vazio, ele não ocupa linha e a altura sai zero.
  marker.textContent = element.value.slice(position) || ".";
  mirror.appendChild(marker);
  document.body.appendChild(mirror);
  try {
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2;
    return {
      top: marker.offsetTop - element.scrollTop,
      left: marker.offsetLeft - element.scrollLeft,
      height: lineHeight,
    };
  } finally {
    document.body.removeChild(mirror);
  }
}
